import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
export default Vue.extend({
    name: 'leverageItemDefault',
    props: {
        searchField: {
            type: String,
            required: true
        },
        dragProcess: {
            type: Boolean,
            required: true
        },
        isMultiSelect: {
            type: Boolean,
            required: true
        },
        folderID: {
            type: Number,
            required: true
        },
        folderIndex: {
            type: Number,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        in_default_folder: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        isLastItem: {
            type: Boolean,
            required: true
        },
        marginType: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        val: {
            type: Number,
            required: true
        },
        previousValue: {
            required: true
        },
        previousMaxValue: {
            required: true
        },
        automaticLeverage: {
            type: Boolean,
            required: true
        },
        isChanged: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        iter: 0,
        value: 0,
        trustedLeftClick: false,
        isViewed: false
    }),
    computed: {
        leverageChangesTooltip() {
            if (this.isChanged) {
                if (this.automaticLeverage) {
                    return !this.isViewed;
                }
                else {
                    return this.val > this.max ? true : !this.isViewed;
                }
            }
            return false;
        },
        leverageChangesTooltipText() {
            if (this.isChanged) {
                const leverageValueChange = this.$t('leveragesPage.leverageValueChange', { from: this.previousMaxValue, to: this.max, name: this.name });
                if (this.automaticLeverage) {
                    return this.previousValue === this.val ? leverageValueChange : leverageValueChange + this.$t('leveragesPage.alsoChanged');
                }
                else {
                    return this.val <= this.max ? leverageValueChange : leverageValueChange + this.$t('leveragesPage.chooseNewLeverage');
                }
            }
            return '';
        },
        marginTypes() {
            const maw = this.maw(480);
            if (maw) {
                return {
                    cross: this.$t('leveragesPage.crossShort'),
                    isolated: this.$t('leveragesPage.isolatedShort')
                };
            }
            return {
                cross: this.$t('leveragesPage.cross'),
                isolated: this.$t('leveragesPage.isolated')
            };
        },
        letCommonChangeVal() {
            const condition = this.selectedMax && this.selected;
            if (condition)
                return this.selectedMax === this.max;
            return true;
        },
        lightedSearchKey() {
            const searchPhrase = this.searchField;
            if (!searchPhrase.length)
                return this.name;
            let name = this.name.toLowerCase();
            if (name.length > 14)
                name = name.substring(0, 11) + '...';
            return name.replace(RegExp(searchPhrase.toLowerCase()), `<i>${searchPhrase.toUpperCase()}</i>`).toUpperCase();
        },
        leverageVal: {
            get() {
                const val = this.val;
                return val;
            },
            set(v) {
                let result = v;
                const max = this.max;
                if (v > max)
                    result = max;
                if (v < 1)
                    result = 1;
                this.$emit('changeVal', result);
            }
        },
        leverageValOrMax() {
            const val = this.leverageVal;
            const max = this.max;
            return Math.min(val, max);
        }
    },
    methods: {
        handleMouseDown(event) {
            var _a, _b;
            const vm = this;
            if (vm.letCommonChangeVal && vm.miw(960)) {
                const { numberBox, slider } = vm.$refs;
                let isSlider = false;
                let isNumberBox = false;
                let isCheckbox = false;
                for (const pathEl of event.path) {
                    if (pathEl === slider.$el)
                        isSlider = true;
                    if (pathEl === numberBox.$el)
                        isNumberBox = true;
                    if ((_a = pathEl === null || pathEl === void 0 ? void 0 : pathEl.classList) === null || _a === void 0 ? void 0 : _a.contains('leverages_no-select'))
                        isSlider = true;
                    if ((_b = pathEl === null || pathEl === void 0 ? void 0 : pathEl.classList) === null || _b === void 0 ? void 0 : _b.contains('leveragesTicker_checkbox'))
                        isCheckbox = true;
                }
                vm.trustedLeftClick = (!isSlider && !isNumberBox && !isCheckbox);
            }
            else
                vm.trustedLeftClick = true;
        },
        handleClick() {
            const vm = this;
            if (vm.trustedLeftClick && !vm.isTouch && vm.miw(960))
                this.$emit('onClick', this.index, this.folderIndex);
            vm.trustedLeftClick = false;
        },
        onMouseLeave() {
            if (this.leverageChangesTooltip) {
                if (!this.automaticLeverage && this.val > this.max)
                    return;
                this.isViewed = true;
                this.$emit('onLeverageChangesViewed');
            }
        }
    },
    components: {
        VueSlider
    }
});
